import { ArrowTriangleLeftIcon } from '@tableau/icons/ArrowTriangleLeftIcon';
import { ArrowTriangleRightIcon } from '@tableau/icons/ArrowTriangleRightIcon';
import * as React from 'react';
import * as TypeStyle from 'typestyle';
import { ButtonType } from '../Button/ButtonWidget';
import { ButtonWidget } from '../Button/ButtonWidgetShim';

export interface CarouselProps extends Pick<React.HTMLAttributes<HTMLElement>, 'id' | 'role' | 'style'> {
  nextButtonTitle?: string;
  onNextClick?: () => void;
  onPreviousClick?: () => void;
  prevButtonTitle?: string;
}

const CarouselStyleName = TypeStyle.style({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
});

const ButtonStyleName = TypeStyle.style({
  height: 30,
  width: 30,
  minWidth: `30px !important`,
  padding: `0 !important`,
  $nest: {
    '& svg': { verticalAlign: 'middle' },
  }
});

export const CarouselWidget: React.FC<CarouselProps> = ({ children, id, nextButtonTitle, onNextClick, onPreviousClick, prevButtonTitle, role, style }) => {
  const [focusWithin, setFocusWithin] = React.useState(false);

  const prevMonthButton = <ButtonWidget
    buttonType={ButtonType.LowEmphasis}
    className={ButtonStyleName}
    children={<ArrowTriangleLeftIcon size={18} aria-hidden />}
    onClick={onPreviousClick}
    testId='stepper-left'
    title={prevButtonTitle}
  />;

  const nextMonthButton = <ButtonWidget
    buttonType={ButtonType.LowEmphasis}
    className={ButtonStyleName}
    children={<ArrowTriangleRightIcon size={18} aria-hidden />}
    onClick={onNextClick}
    testId='stepper-right'
    title={nextButtonTitle}
  />;

  return (
    <div className={CarouselStyleName} onBlur={() => setFocusWithin(false)} onFocus={() => setFocusWithin(true)} style={style}>
      {prevMonthButton}
      <span id={id} role={role} aria-live={focusWithin ? 'assertive' : 'off'} aria-atomic={true}>
        {children}
      </span>
      {nextMonthButton}
    </div>
  );
};
CarouselWidget.displayName = 'CarouselWidget';
